import React from "react";
import TableView from "../../tables/TableView";
import AddNewButton from "../../buttons/AddNewButton";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";

const headers = [
    {"label": "Nazov", "caption": "Názov", 'filter': 'string'},
]

function ServiceCaseStates(props) {
    const initialFilters = [
        {
            'label': 'Nazov',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Stav',
        }
    ]
    const baseUrl = '/service_case/service_cases_state_categories'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Nazov': `/service_case_state_categories/service_case_state_category/${entry.id}`
        }))
    }


    return (
        <ListViewCommon baseUrlFrontend={`/service_case_state_categories/service_case_state_category`}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Kategórie stavov servisných prípadov"}
        />
    )
}

export default ServiceCaseStates
